module.exports = __webpack_public_path__ + "static/media/facebookArticle.b44e2efe.svg";